import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";
import FixedNavBar from "@/components/fixedNavBar";
import VaultBalance from "./comp/VaultBalance";
import MonthlyWeger from "./comp/MonthlyWeger";
import TableeHead from "@/components/tableHead";
import TableTbody from "@/components/tableTbody";
import useRouter from "@/hooks/useRouter";
import API from "@/api";
import useCustomTranslation from "@/hooks/useTranslation";
import { ITableColsGameRecords, ITableColsRecentlyHome } from "@/type";

const Home: React.FC = () => {
	const classes = useStyles();
	const { customNavigate } = useRouter();
	const { t } = useCustomTranslation();
	const [dataList, setDataList] = useState<Record<string, any>>({});

	const getFinanceAgentHomeHandle = async () => {
		try {
			const result: any = await API.finances.apiFinanceAgentHome();
			if (result?.code === 0) {
				const contentData = result.content.data;
				setDataList(contentData);
			}
		} catch (error) {
			console.log("---apiFinanceAgentHome--:", error);
		}
	};
	useEffect(() => {
		getFinanceAgentHomeHandle();
	}, []);

	return (
		<div className="router-main">
			{/*  backArrow={false} {t("hello")}*/}
			<FixedNavBar title={t("AdminPanel")} />
			<div className="router-view">
				<div className={classes.homeWrap}>
					<VaultBalance data={dataList} />
					<MonthlyWeger data={dataList} />
					<TableeHead
						title={t("GameRecords")}
						isMore={true}
						onMore={() => {
							customNavigate("/game-records?t=" + Date.now());
						}}
					/>
					<TableTbody
						ITableCols={ITableColsGameRecords}
						ITableData={dataList.recordList}
						styleRich={{
							border: "1px solid #353F63",
							minHeight: pxToRem(234),
						}}
						handleRefresh={function (): Promise<any> {
							throw new Error("Function not implemented.");
						}}
						handleFetchMore={function (
							isRetry: boolean
						): Promise<void> {
							throw new Error("Function not implemented.");
						}}
						hasMore={false}
						isPullToRefresh={false}
					/>
					<div style={{ height: pxToRem(10) }}>&nbsp;</div>
					<TableeHead
						title={t("btnDepositWithdrawRecords")}
						isMore={true}
						onMore={() => {
							customNavigate(
								"/recently-recharge?t=" + Date.now()
							); //最近充值
						}}
					/>
					<TableTbody
						ITableCols={ITableColsRecentlyHome}
						ITableData={dataList.rechargeList}
						styleRich={{
							border: "1px solid #353F63",
							minHeight: pxToRem(234),
						}}
						handleRefresh={function (): Promise<any> {
							throw new Error("Function not implemented.");
						}}
						handleFetchMore={function (
							isRetry: boolean
						): Promise<void> {
							throw new Error("Function not implemented.");
						}}
						hasMore={false}
						isPullToRefresh={false}
					/>
				</div>
			</div>
		</div>
	);
};

export default Home;

const useStyles = createUseStyles({
	homeWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(30),
		},
		display: "flex",
		flexDirection: "column",
	},
});
